import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

class SkioBundler extends LitElement {
  static properties = {
    product: { type: Object },
    selectedVariant: { type: Object },
    _boxData: { type: Object },
    form: { type: Element },
    addToCartButton: { type: Element },
    currency: { type: String }, //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String }, //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {}, //placeholder for object
    _displayWarning: { type: Boolean, default: false },

    _giftOptions: { type: Array },
    _isGift: { type: Boolean, default: false },
  };

  static styles = css`
    :host {
      margin-bottom: 1rem;
      display: block;
      font-family: inherit;
      position: relative;
    }

    .box-wrapper {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
    }

    .box-item {
      border-radius: 4px;
      border: 1px solid #e4e7e4;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: black;
      font-size: 16px;
      text-align: center;
    }

    .box-item--selected {
      border-color: #000;
    }

    .box-item img {
      width: 100%;
      padding-top: 15px;
    }

    .quantity-selector {
      width: 100%;
      display: flex;
      border-top: 1px solid var(--color-boder-light);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: grid;
      background: #fff;
      grid-template-columns: 1fr 1fr 1fr;
      margin: auto 0 0 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      overflow: hidden;
    }

    .quantity-selector button {
      border: none;
      font-size: 18px;
      opacity: 1;
      cursor: pointer;
      padding: 5px 0;
      background: #f8f8f8;
    }

    .quantity-selector input {
      text-align: center;
      border: none;
      width: 100%;
      color: #092803;
      font-family: inherit;
    }

    @media (min-width: 768px) {
      .box-wrapper {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }

    @media (min-width: 748px) and (max-width: 850px) {
      .box-item {
        font-size: 12px;
      }
    }

    .alert-container {
      max-width: 90%;
      width: 90%;
      padding: 16px;
      display: grid;
      grid-template-columns: 1fr 20fr;
      column-gap: 5px;
      background-color: #327830;
      border-radius: 8px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 5;
      color: white;
    }

    .alert-header {
      display: flex;
      justify-content: space-between;
    }

    .alert-title {
      width: fit-content;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #fff;
    }

    .alert-close {
      width: fit-content;
      cursor: pointer;
    }

    .alert-icon {
      margin-top: 2px;
    }

    .alert-message {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #fffc;
    }

    .alert-backdrop {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .gift-option {
      padding: 0;
      margin: 0 0 1.2rem;
      border: none;

      width: 100%;
    }

    .gift-option legend {
      font-size: 1.3rem;
      line-height: calc(1 + .5 / var(--font-body-scale));
      margin-bottom: 0.2rem;
    }

    .gift-option input {
      display: none;
    }
    
    .gift-option label {
      font-size: 16px;
      padding: 15px;
      background-color: transparent;
      border-radius: 4px;
      color: rgba(var(--color-foreground),.75);
      border: 1px solid #E4E7E4;

      display: inline-block;
      margin: 0.7rem 0.5rem 0.2rem 0;

      cursor: pointer;
    }

    .gift-option input[type=radio]:checked+label {
      border: 1px solid #000000;
      color: #000;
    }
  `;

  constructor() {
    super();

    this.product = null;
    this.selectedVariant = null;
    this.form = null;
    this._displayWarning = false;
    
    this._giftOptions = [
      {
        handle: 'hamama-gold-accessory-bag',
        selected: true,
        product: {}
      },
      {
        handle: 'pre-wrapped-gift-box',
        selected: true,
        product: {}
      },
    ];

    this.currency = Shopify.currency.active;
    this.language = "en-US";
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: this.currency,
    });

    this.productTitlesToHide = ['Red Radish Seed Quilt', 'Pink Radish Seed Quilt', 'Violet Radish Seed Quilt', 'Hot Wasabi Mustard Seed Quilt', 'Rainbow Radish Seed Quilt'];
  }

  async connectedCallback() {
    super.connectedCallback();

    // if(this.product.title.includes('- Gift')) {
    //   this._isGift = true;
    //   this.fetchGifts();
    // }
    
    this.bindEvents();

    await this.fetchAllBoxData();
    this.getActiveBox();
  }

  bindEvents() {
    this.form = this.closest('form[action="/cart/add"]');

    if (this.form) {
      const variantInput = this.form.querySelector('[name="id"]');

      if (variantInput) {
        variantInput.addEventListener("change", (e) => {
          this.selectedVariant = this.product.variants.find(
            (variant) => variant.id == e.target.value
          );
        });
      }

      this.addToCartButton = this.form.querySelector('[type="submit"]');

      if(this._isGift && this.addToCartButton) {
        this.addToCartButton.addEventListener('click', async (event) => {
          if(!event.isTrusted) return;
          
          event.preventDefault();

          const cart = await this.fetchCart();
          const cartItemIds = cart.items.map(item => item.id);

          const items = this._giftOptions.filter(gift => gift.selected).map(gift => ({
            id: gift.product.variants[0].id,
            quantity: 1
          })).filter(item => !cartItemIds.includes(item.id));

          if(items.length) {
            await this.addToCart(items);
          } 

          event.target.click();
        });
      }
    }
  }

  log = (...args) => {
    args.unshift("%c[skio]", "color: #8770f2;");
    console.log.apply(console, args);
  };

  error = (...args) => {
    args.unshift("%c [skio]", "color: #ff0000");
    console.error.apply(console, args);
  };

  updated = (changed) => {
    if (this.addToCartButton) {
      if (this.canCheckout()) {
       if(this._boxData){
         this.addToCartButton.disabled = false;
         this.addToCartButton.textContent = "Add to cart";
       }
      } else {
        this.addToCartButton.disabled = true;
        if (this._boxData) {
          this.addToCartButton.textContent = `Only ${this.totalQuantity()} out of ${
            this._boxData.size
          } selected`;
        }
      }
    }

    if (changed.has("selectedVariant") && this.selectedVariant) {
      this.getActiveBox();
    }

    this.createProperties();
  };

  boxItem(item) {
    if(this.productTitlesToHide.includes(item.productTitle)) return; 
    
    return html`
      <div class="box-item ${item.quantity > 0 ? "box-item--selected" : ""}">
        <img src="${item.imageSrc}" />

        <p>${item.productTitle.replace("Seed Quilt", "")}</p>

        <div class="quantity-selector">
          <button @click="${() => this.updateQuantity(item, -1)}">-</button>
          <input readonly min="0" type="number" .value="${item.quantity}" />
          <button @click="${() => this.updateQuantity(item, 1)}">+</button>
        </div>
      </div>
    `;
  }

  quantityAlert() {
    return html`
      <div
        class="alert-backdrop"
        @click=${() => (this._displayWarning = false)}
      ></div>
      <div class="alert-container" id="alert" style="display: grid;">
        <div class="alert-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.63627 0.00465324C9.22027 0.0246372 8.95819 0.0474132 8.62427 0.0926133C7.25683 0.277709 5.90534 0.766653 4.71627 1.50647C3.77292 2.0934 2.91252 2.85694 2.19948 3.73996C1.46832 4.64541 0.886978 5.7104 0.51241 6.83058C0.260442 7.5841 0.105026 8.3359 0.0366422 9.13196C0.00923425 9.45101 0.00437825 9.58154 0.00437825 9.99996C0.00437825 10.4756 0.0162822 10.7119 0.0606022 11.116C0.221538 12.5832 0.719658 14.0188 1.50678 15.284C2.17857 16.3637 3.08011 17.3323 4.12027 18.092C4.92744 18.6815 5.86135 19.1625 6.82827 19.4868C7.57963 19.7388 8.33487 19.8951 9.13227 19.9636C9.44993 19.9909 9.58202 19.9958 10.0003 19.9958C10.4763 19.9958 10.7128 19.9839 11.1163 19.9396C12.5834 19.7787 14.0193 19.2805 15.2843 18.4934C15.7706 18.1909 16.2224 17.8508 16.6883 17.4368C16.8278 17.3127 17.313 16.8275 17.4371 16.688C18.0771 15.9679 18.5507 15.2701 18.9602 14.444C19.5171 13.3204 19.847 12.1556 19.9605 10.9127C19.9753 10.7499 19.9922 10.47 19.9922 10.386C19.9923 10.3366 19.9955 10.304 20.0003 10.304C20.0055 10.304 20.0082 10.194 20.0081 9.98996C20.0081 9.78428 20.0053 9.68009 20.0003 9.68796C19.995 9.69613 19.9925 9.67316 19.9924 9.61596C19.9921 9.4781 19.9678 9.13955 19.9399 8.88396C19.7796 7.41873 19.2807 5.98084 18.4938 4.71596C18.1317 4.13397 17.7129 3.59571 17.2333 3.09596C16.3978 2.22529 15.4995 1.56307 14.4443 1.04004C13.2375 0.441885 12.0258 0.116005 10.6487 0.0192452C10.4891 0.00803724 9.77897 -0.00219476 9.63627 0.00465324ZM9.72027 1.25617C8.52971 1.29425 7.42023 1.55603 6.33227 2.05556C4.89592 2.71505 3.63569 3.78813 2.74248 5.11225C1.93862 6.30392 1.44197 7.67499 1.29656 9.10396C1.25594 9.50321 1.24193 10.087 1.26375 10.472C1.32811 11.6077 1.58408 12.6404 2.05587 13.668C2.66286 14.99 3.61314 16.1555 4.80711 17.0422C5.52756 17.5773 6.36783 18.0131 7.24155 18.3046C7.87498 18.5159 8.52521 18.6515 9.19227 18.7114C9.48456 18.7376 9.67387 18.7456 10.0003 18.7456C10.5783 18.7456 11.054 18.7033 11.5996 18.6032C12.7598 18.3904 13.8999 17.9242 14.8846 17.26C15.6192 16.7645 16.2942 16.1402 16.8525 15.44C17.5633 14.5484 18.0954 13.515 18.4127 12.4096C18.5947 11.7758 18.6979 11.1577 18.7369 10.468C18.7485 10.262 18.7485 9.7379 18.7369 9.53196C18.6674 8.30272 18.3756 7.19624 17.8321 6.09996C17.3099 5.04671 16.5863 4.12281 15.6643 3.33186C14.5347 2.36296 13.1272 1.68859 11.6403 1.40395C11.037 1.28846 10.354 1.23589 9.72027 1.25617ZM9.52894 5.01287C9.08342 5.08752 8.75227 5.48103 8.75227 5.93579C8.75227 6.13112 8.80116 6.2941 8.90831 6.45596C9.04565 6.6634 9.25753 6.8057 9.50427 6.85621C9.61494 6.87888 9.80648 6.87527 9.91195 6.84854C10.4445 6.7136 10.75 6.15507 10.5751 5.63596C10.4976 5.40621 10.3202 5.20361 10.1003 5.09376C9.93954 5.01349 9.71496 4.98169 9.52894 5.01287ZM8.59405 8.14344C8.37647 8.19689 8.18765 8.39125 8.13992 8.61089C8.11925 8.70601 8.12648 8.86197 8.15555 8.94796C8.22051 9.14009 8.38032 9.29359 8.57755 9.35327C8.63384 9.3703 8.65154 9.37116 9.0061 9.374L9.37594 9.37697L9.37825 11.0425L9.38055 12.708L9.39819 12.804C9.43485 13.0035 9.48071 13.1458 9.56315 13.316C9.80797 13.8212 10.2644 14.1901 10.8092 14.3229C11.0002 14.3694 11.0372 14.372 11.5283 14.372C11.974 14.372 11.9811 14.3717 12.0427 14.3539C12.3392 14.268 12.5279 13.9884 12.4961 13.6825C12.4829 13.5558 12.444 13.462 12.3622 13.359C12.2851 13.262 12.153 13.1736 12.0395 13.1431C12.016 13.1368 11.8643 13.1317 11.5843 13.1277C11.1102 13.1211 11.1015 13.1201 10.9803 13.0609C10.8161 12.9807 10.7021 12.845 10.6468 12.664L10.6285 12.604L10.624 10.908C10.6191 9.10737 10.6209 9.19238 10.5845 9.05596C10.4567 8.57672 10.0528 8.21378 9.56427 8.13923C9.50979 8.13092 9.39 8.12835 9.07227 8.12869C8.6969 8.12909 8.64608 8.13065 8.59405 8.14344ZM0.00390625 9.99996C0.00390625 10.1738 0.00496225 10.2449 0.00625825 10.158C0.00754625 10.0711 0.00754625 9.92885 0.00625825 9.84196C0.00496225 9.75506 0.00390625 9.82616 0.00390625 9.99996Z"
              fill="white"
            ></path>
          </svg>
        </div>

        <div class="alert-content">
          <div class="alert-header">
            <div class="alert-title">Maximum Selected</div>
            <div
              class="alert-close"
              @click=${() => (this._displayWarning = false)}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.308058 0.308058C0.552136 0.0639806 0.947864 0.0639806 1.19194 0.308058L7 6.11612L12.8081 0.308058C13.0521 0.0639806 13.4479 0.0639806 13.6919 0.308058C13.936 0.552136 13.936 0.947864 13.6919 1.19194L7.88388 7L13.6919 12.8081C13.936 13.0521 13.936 13.4479 13.6919 13.6919C13.4479 13.936 13.0521 13.936 12.8081 13.6919L7 7.88388L1.19194 13.6919C0.947864 13.936 0.552136 13.936 0.308058 13.6919C0.0639806 13.4479 0.0639806 13.0521 0.308058 12.8081L6.11612 7L0.308058 1.19194C0.0639806 0.947864 0.0639806 0.552136 0.308058 0.308058Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
          <div class="alert-message">
            You’ve selected the maximum allowed number of seed quilts. To add
            another seed quilt, please remove one that’s already been added.
          </div>
        </div>
      </div>
    `;
  }

  giftingOptions() {
    return html`
      ${this._giftOptions.filter(gift => Object.keys(gift.product).length).length && this._giftOptions.map((gift, index) => html`
        <fieldset class="gift-option">
          <legend>Add a ${gift.product?.title?.toLowerCase()} for ${this.moneyFormatter.format(gift.product?.variants?.[0].price / 100)}</legend>
          
          <input type="radio" id="gift_option_yes-${index}" name="gift_option-${index}" value="true" .checked=${gift.selected} @change=${() => gift.selected = true}>
          <label for="gift_option_yes-${index}">Yes ${gift.product?.title?.toLowerCase()}</label>
          
          <input type="radio" id="gift_option_no-${index}" name="gift_option-${index}" value="false" .checked=${!gift.selected} @change=${() => gift.selected = false}>
          <label for="gift_option_no-${index}">No ${gift.product?.title?.toLowerCase()}</label>
        </fieldset>
      `)}
    `;
  }

  render() {
    if (!this.product || !this.selectedVariant || !this._boxData) return;

    return html`
      ${this._isGift ? this.giftingOptions() : ''}

      Choose ${this._boxData.size} Seed Quilts:
      ${this.totalQuantity()}/${this._boxData.size} Selected

      <div class="box-wrapper">
        ${this._boxData.selectableProductVariants.map((variant) =>
          this.boxItem(variant)
        )}
      </div>

      ${this._displayWarning ? this.quantityAlert() : ""}
    `;
  }

  updateQuantity(item, value) {
    const quantity = item.quantity;
    let newQuantity = quantity + value;

    if (value + this.totalQuantity() > this._boxData.size) {
      newQuantity = item.quantity;
      this._displayWarning = true;
    } else if (newQuantity < 0) {
      newQuantity = 0;
    }

    item.quantity = newQuantity;

    this.requestUpdate();
  }

  totalQuantity() {
    if (!this._boxData) return 0;

    const sum = this._boxData.selectableProductVariants.reduce(
      (acc, obj) => acc + obj.quantity,
      0
    );
    return sum;
  }

  canCheckout() {
    if(!this._boxData) return true;
    return this.totalQuantity() === this._boxData?.size;
  }

  createProperties() {
    if(!this._boxData) return;
    
    this.replaceChildren();

    for(const [index, item] of this._boxData.selectableProductVariants.entries()) {
      if(item.quantity > 0) {
        const boxItem = document.createElement('input');
        boxItem.type = 'hidden';
        boxItem.name = `properties[_pv${item.platformId}]`
        boxItem.value = item.quantity;
        this.appendChild(boxItem);
      }

      const displayItem = document.createElement('input');
      displayItem.type = 'hidden';
      displayItem.name = `properties[Seed Quilt #${index + 1}]`
      displayItem.value = item.quantity > 0 ? `${item.quantity}x ${item.productTitle}` : '';
      this.appendChild(displayItem);
    }

    const classicBoxInput = document.createElement('input');
    classicBoxInput.type = 'hidden';
    classicBoxInput.name = `properties[_isClassicBoxV2]`
    classicBoxInput.value = true;

    this.appendChild(classicBoxInput)
  }

  async getActiveBox() {
    if (!this.product || !this.selectedVariant) return;

    const boxCache = JSON.parse(sessionStorage.getItem('skio-boxes')) || [];
    const boxMatch = boxCache.find(box => box.platformId == 'gid://shopify/ProductVariant/' + this.selectedVariant.id);

    if(boxMatch) {
      this.log('box match found in cache', this._boxData);
      this._boxData = boxMatch;
    } else {
      this._boxData = await this.fetchBoxData(this.selectedVariant?.id, this.selectedSellingPlan?.id);
    }
    
    // Create hidden form properties for ATC
    await this.createProperties();
  }

  async fetchAllBoxData() {
    if(!this.product) return;

    const { variants } = this.product;

    await Promise.all(variants.map(async (variant) => {
        const box = await this.fetchBoxData(variant.id);
        return box;
      }
    ));
  }

  async fetchBoxData(variantId, sellingPlanId = '') {
    return new Promise((resolve, reject) => {
      if (!variantId) reject('No variant ID provided');

      const existingBoxData = JSON.parse(sessionStorage.getItem('skio-boxes')) || [];
      const existingBox = existingBoxData.find(box => box.platformId == 'gid://shopify/ProductVariant/' + variantId);
      if(existingBox) {
        this.log('using cached box data')
        return resolve(existingBox);
      }

      fetch("https://api.skio.com/storefront-http/get-classic-box-v2", {
        method: "POST",
        body: JSON.stringify({
          productVariantPlatformId: variantId,
          sellingPlanPlatformId: sellingPlanId,
          region: "us-west-2",
          userPoolId: "us-west-2_ky2hNEMAZ",
        }),
      })
      .then((response) => response.json())
      .then((response) => {
        if(!response.ok) reject(response);

        let { ClassicBoxV2: box } = response;

        // Set the default quantities for box size
        const { size, selectableProductVariants } = box;
        const filteredSelectableProductVariants = selectableProductVariants.filter(variant => !this.productTitlesToHide.includes(variant.productTitle));
        const length = filteredSelectableProductVariants.length;
        let count = 0;
        const split = size < length ? 1 : Math.round(size / length);

        for (const [
          index,
          variant,
        ] of filteredSelectableProductVariants.entries()) {
          variant.quantity = split;
          count += split;

          if (index === length - 1 && count !== size) {
            variant.quantity += size - count;
          }

          if (count == size) {
            break;
          }
        }

        box.selectableProductVariants = filteredSelectableProductVariants;

        // Cache box data to reduce call requests
        const boxCache = JSON.parse(sessionStorage.getItem('skio-boxes')) || [];
        boxCache.push(box);
        sessionStorage.setItem('skio-boxes', JSON.stringify(boxCache));

        // Return box data
        resolve(box);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  async fetchGifts() {
    const productsToFetch = this._giftOptions.map(gift => this.fetchProduct(gift.handle));

    await Promise.all(productsToFetch).then((products) => {
      for(const product of products) {
        const matchingGift = this._giftOptions.find(gift => gift.handle == product.handle)
        if(matchingGift) matchingGift.product = product;
      }
    });
  }

  async fetchProduct(handle) {
    return new Promise((resolve, reject) => {
      fetch(`${window.location.origin}/products/${handle}.js`)
      .then((response) => response.json())
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  }

  async fetchCart() {
    return new Promise((resolve, reject) => {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addToCart(items) {
    return new Promise((resolve, reject) => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })
      .then((response) => response.json())
      .then((response) => {
        this.log("SKIO added item to cart: ", response);
        resolve(response)
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error);
        reject(error)
      });
    });
  }
}

customElements.define("skio-bundler", SkioBundler);
